var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-with-top-bar"},[_c('project-admin-quick-buttons',{attrs:{"hiddenOption":"report-config"}}),_vm._v(" "),_c('section',[_c('div',{staticClass:"mt-4"},[_c('report-templates',{attrs:{"project-id":_vm.projectId,"activity-groups":_vm.activityGroups}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }